<div class="component-container" (clickOutside)="close($event)" (click)="toggle()" [class.opened]="opened">
  <span>
    {{caption}}
  </span>
  <div *ngIf="opened" class="options-wrapper" [style]="menuStyle">
    <ng-content></ng-content>
  </div>
</div>